<template>
  <div class="card shadow-1 q-px-lg">
    <div style="text-align: start" class="q-mb-md">
      <h3 style="font-size: 20px; gap: 10px;" class="tw-flex">
        {{$gettext('PLOTS')}}
      </h3>
    </div>
    <div v-if="dataColumns">
      <div
        v-for="(installment, index) in groupedInstallments"
        :key="index"
        :class="{ table: index === 0 }"
        class="q-mb-md"
      >
        <header-colapse-table-installment
          :headerData="getHeaderData(installment.items, index)"
          :shouldDisableExtend="shouldDisableExtendButtonForItem"
          :shouldDisableVisualize="shouldDisableVisualizeInvoiceDocumentButton"
          :openExtendModal="openExtendModalForItem"
          :openInvoiceManager="openInvoiceManagerCommon"
          @colapse="() => toggleInstallment(index)"
        />
        <jt-data-table
          v-if="isInstallmentOpen[index]"
          :api-mode="false"
          class="tw-w-full"
          :data="getAssignedInvoiceData(groupedInstallments[index].items)"
          :fields="dataColumns.columns"
          :buttons="dataColumns.buttons"
          :is-paginated="false"
          :title="titleTeble"
          ref="datatable"
          :rows-per-page-options="[0]"
        >
          <template #header="{ props }">
            <q-tr :props="props" class="table-header">
              <q-th v-for="col in getFilteredColumns(props.cols)" :key="col.name" :props="props">
              {{ col.label }}
              </q-th>
              <q-th style="width: 1px"/>
            </q-tr>
          </template>
       <template #body="{props}">
      <q-tr class="text-left">
        <q-td v-for="col in getFilteredColumns(props.cols)" :key="col.name" :props="props" style="color: #333">
            <span v-if="col.name === 'feesAfterDiscount' || col.name === 'fineAfterDiscount'
                  || col.name === 'correctionAfterDiscount' ||  col.name === 'amortization'">
              {{ $toLocaleStringBr(col.value) }}
            </span>
            <span v-else>
              {{ col.value }}
            </span>
         </q-td>
        </q-tr>
    </template>
    </jt-data-table>
      </div>
    </div>

    <InstallmentExtensionModal
      v-if="modalShow"
      :show="modalShow"
      :selectedRow="selectedRowForModal"
      @close-modal="closeModal"
      @refresh-table="refreshTable"
    />
    <JtDocsViewer
      :src="fileSrc"
      :title="$gettext('EXTENDED_INVOICE_DOCUMENT')"
      pdf
      ref="reportModal"
    />
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtDataTable, JtDocs } from 'jtech-webcomps'
import { repository, messageBox } from 'src/jtech'
import InstallmentExtensionModal from './InstallmentExtensionModal.vue'
import HeaderColapseTableInstallment from './HeaderColapseTableInstallment.vue'
import { isLate } from 'src/shared/global/UtilDate'
import { situationMap } from '../../../../../../agreement-report/agreement-situation.config'

const { JtDocsViewer } = JtDocs

@Component({
  name: 'Installment',
  components: {
    JtDataTable,
    InstallmentExtensionModal,
    JtDocsViewer,
    HeaderColapseTableInstallment
  },
  props: {
    data: Object
  }
})
class Installment extends Vue {
  dataColumns = {};
  dataTable = [];
  openStatus = situationMap.PENDING.keys[1];
  extendedStatus = situationMap.EXTENDED.keys[1];
  modalShow = false
  fileSrc = null;
  pdfEndpoint = 'invoiceDocument.pesquisarInvoiceDocumentPdfById';
  isInstallmentOpen = [];
  selectedRowForModal = {};

  getHeaderData (items, index) {
    return {
      installmentNumber: index + 1,
      items: items,
      columns: this.dataColumns.columns,
      labels: this.getColumnLabels(),
      totalItems: items.length
    }
  }

  get groupedInstallments () {
    if (!this.dataTable || this.dataTable.length === 0) {
      return []
    }
    return this.dataTable.map(item => ({
      items: [item]
    }))
  }

  getColumnLabels () {
    if (!this.dataColumns || !this.dataColumns.columns) {
      return {}
    }
    const labels = {}
    this.dataColumns.columns
      .filter(col => col.type !== 'HIDDEN')
      .forEach(col => {
        labels[col.name] = col.label
      })
    return labels
  }

  toggleInstallment (index) {
    this.$set(this.isInstallmentOpen, index, !this.isInstallmentOpen[index])
  }

  async openInvoiceManagerCommon (row) {
    const { pdf } = await repository.resolveLogic(this.pdfEndpoint, { invoiceDocument: row.invoiceDocument })
    await this.__whenGenerationFormatIsOnline({ nmArquivo: pdf })
  }

  async __whenGenerationFormatIsOnline ({ nmArquivo }) {
    try {
      const result = await this.$jt.repository.downloadFile(
        nmArquivo,
        'pdf',
        '',
        'application/pdf'
      )
      this.fileSrc = URL.createObjectURL(result)
      this.$nextTick(() => {
        this.$refs.reportModal.show()
      })
      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    }
  }

  closeModal () {
    this.modalShow = false
  }

  refreshTable () {
    this.searchInstallmentData()
  }

  shouldDisableExtendButtonForItem (item) {
    if (!item) return true
    return item.agreementInvoiceStatus != this.openStatus || isLate(item.dueDate)
  }

  openExtendModalForItem (item) {
    this.selectedRowForModal = item
    this.modalShow = true
  }

  shouldDisableVisualizeInvoiceDocumentButton (row) {
    console.log('shouldDisableVisualize - barCode:', row.barCode, 'agreementInvoiceStatus:', row.agreementInvoiceStatus, 'openStatus:', this.openStatus, 'extendedStatus:', this.extendedStatus)
    const status = String(row.agreementInvoiceStatus)
    return row.barCode == null || (status !== String(this.openStatus) && status !== String(this.extendedStatus))
  }

  async mounted () {
    this.dataColumns = await repository.resolveDatatable(
      'invoiceDocumentSearches.pesquisarInstallments'
    )

    const hasRefColumn = this.dataColumns.columns.some(col => col.name === 'ref')
    if (!hasRefColumn) {
      this.dataColumns.columns.push({
        name: 'ref',
        label: this.$gettext('REFERENCE'),
        field: 'ref',
        align: 'center',
        type: 'STRING'
      })
    }

    const hasAmortizationColumn = this.dataColumns.columns.some(col => col.name === 'amortization')
    if (!hasAmortizationColumn) {
      this.dataColumns.columns.push({
        name: 'amortization',
        label: this.$gettext('AMORTIZATION'),
        field: 'amortization',
        align: 'center',
        type: 'STRING'
      })
    }

    await this.searchInstallmentData()
  }

  async searchInstallmentData () {
    const result = await repository.resolveDatatableModel(
      'invoiceDocumentSearches.pesquisarInstallments',
      { agreementInvoice: this.data.id }
    )
    this.dataTable = result.registros
  }

  getAssignedInvoiceData (items) {
    if (!items || items.length === 0) {
      return []
    }

    const assignedInvoices = []

    items.forEach(item => {
      if (item.assignedInvoice) {
        try {
          const fallbackData = this.parseAssignedInvoiceFallback(item.assignedInvoice)
          if (fallbackData && Array.isArray(fallbackData)) {
            fallbackData.forEach(invoice => {
              assignedInvoices.push(this.processInvoiceItem(invoice, item))
            })
          }
        } catch (fallbackError) {
          assignedInvoices.push(item)
        }
      }
    })

    return assignedInvoices
  }

  parseAssignedInvoiceFallback (assignedInvoiceString) {
    try {
      const sanitizedContent = this._sanitizeInvoiceString(assignedInvoiceString)
      const objectStrings = this._splitIntoObjectStrings(sanitizedContent)
      return this._parseObjectStrings(objectStrings)
    } catch (error) {
      return null
    }
  }

  _sanitizeInvoiceString (invoiceString) {
    let content = invoiceString.trim()
    if (content.startsWith('[{') && content.endsWith('}]')) {
      content = content.slice(2, -2)
    }
    return content
  }

  _splitIntoObjectStrings (content) {
    return content.split(/},\s*{/)
  }

  _parseObjectStrings (objectStrings) {
    const objects = []

    objectStrings.forEach(objStr => {
      const parsedObject = this._parseObjectString(objStr)
      if (this._isValidObject(parsedObject)) {
        objects.push(parsedObject)
      }
    })

    return objects
  }

  _parseObjectString (objStr) {
    const obj = {}
    const pairs = this._extractKeyValuePairs(objStr)

    pairs.forEach(pair => {
      const keyValue = this._parseKeyValuePair(pair)
      if (keyValue) {
        obj[keyValue.key] = keyValue.value
      }
    })

    return obj
  }

  _extractKeyValuePairs (objStr) {
    return objStr.replace(/[{}]/g, '').split(',')
  }

  _parseKeyValuePair (pair) {
    const [key, value] = pair.split('=').map(s => s.trim())

    if (!key || value === undefined) {
      return null
    }

    return {
      key,
      value: this._convertValueToProperType(value)
    }
  }

  _convertValueToProperType (value) {
    if (this._isNumericValue(value)) {
      return parseFloat(value)
    }

    if (this._isBooleanValue(value)) {
      return value === 'true'
    }

    return value
  }

  _isNumericValue (value) {
    return !isNaN(value) && !isNaN(parseFloat(value))
  }

  _isBooleanValue (value) {
    return value === 'true' || value === 'false'
  }

  _isValidObject (obj) {
    return Object.keys(obj).length > 0
  }

  processInvoiceItem (invoice, originalItem = null) {
    const processedInvoice = { ...invoice }

    this._processDueDateField(processedInvoice)
    return processedInvoice
  }

  _processDueDateField (invoice) {
    if (!invoice.dueDate) return

    try {
      const date = new Date(invoice.dueDate)
      invoice.dueDate = date.toLocaleDateString('pt-BR')
    } catch (error) {
      invoice.dueDate = invoice.due
    }
  }

  _processOriginalAmountField (invoice) {
    if (invoice.originalAmount) return

    const amountComponents = this._getAmountComponents(invoice)
    invoice.originalAmount = this._calculateTotalAmount(amountComponents)
  }

  _getMonetaryFieldNames () {
    return [
      'amortization',
      'feesAfterDiscount',
      'fineAfterDiscount',
      'interest',
      'correctionAfterDiscount',
      'nominalValue',
      'originalAmount'
    ]
  }

  getFilteredColumns (cols) {
    const allowedFields = ['ref', 'dueDate', 'amortization', 'feesAfterDiscount', 'fineAfterDiscount',
      'correctionAfterDiscount']

    return cols
      .filter(col => allowedFields.includes(col.name))
      .sort((a, b) => allowedFields.indexOf(a.name) - allowedFields.indexOf(b.name))
  }
}
export default Installment
</script>

<style scoped>
.card {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.table-wrapper {
  overflow-x: auto;
  max-width: 100%;
}

.installment-header {
  transition: background-color 0.2s ease;
}

.installment-header:hover {
  background-color: #eeeeee !important;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
